"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debug = exports.debuggers = void 0;

var debug_1 = __importDefault(require("debug"));

var hooks_1 = require("../hooks");

exports.debuggers = {};
exports.debug = {
  namespace: "reactify-search",
  log: function log(namespace, formatter) {
    var _exports$debuggers;

    if (!exports.debuggers[namespace]) {
      exports.debuggers[namespace] = (0, debug_1.default)("".concat(exports.debug.namespace, ":").concat(namespace));
    }

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    (_exports$debuggers = exports.debuggers)[namespace].apply(_exports$debuggers, [formatter].concat(args));
  },
  hook: hooks_1.useDebugger
};